import React, {useState, useEffect /*, useContext */ } from 'react';
import { Card, Row, Col, Statistic, Divider, Button } from 'antd';
import { TeamOutlined, CalendarOutlined, MergeCellsOutlined } from '@ant-design/icons';
import { motion } from 'motion/react';
import _ from 'lodash';
import AddStageParticipant from '../../components/AddStageParticipant';
import { dateFormat } from '../../utils';
import RankingTable from '../../components/RankingTable';
import ParticipantTable from '../../components/ParticipantTable';
import WaitlistTable from '../../components/WaitlistTable';
import * as Setting from '../../utils/AuthUtils';
import SubscribeStage from '../../components/SubscribeStage';


function Stage(props) {
  const [loading, setLoading] = useState(false)
  const [editable, setEditable] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false);
  const [hasRights, setHasRights] = useState({isAdmin: false, isReferral: false});
  const [isRegistered, setIsRegistered] = useState({registered: false, info: null});
  console.warn('props di stage: ',props);

  useEffect(() => {
    Setting.getUserinfo()
        .then(
          (result) => {
            setIsAdmin(result.payLoad.isAdmin);
            const rights = {isAdmin: false, isReferral: false};
            const lref = (props.stage && props.stage.payLoad && props.stage.payLoad ? props.stage.payLoad.seasonInfo.hostingLeague.referrerId : 0 )
            const cdref = (props.stage && props.stage.payLoad && props.stage.payLoad ? props.stage.payLoad.seasonInfo.hostingLeague.casdoorId : '' )
            rights.isAdmin = result.payLoad.isAdmin;
            rights.isReferral = ((result.payLoad.p_id === lref || result.payLoad.u_id === cdref) ? true : false);
            setHasRights(rights)
            // console.warn('sono permessi ho?', hasRights);
            if (result && result.payLoad) {
              if (result.payLoad.stageSubscribed && result.payLoad.stagesSubscribed.length > 0 && result.payLoad.stagesSubscribed.includes(parseInt(props.id))) {
                const stageInfo = _.filter(result.payLoad.stagesSubscribedInfo, {'id': parseInt(props.id)})
                setIsRegistered({registered: true, info: stageInfo});
                // console.warn('sono registrato:', isRegistered);
              }
            }
          },
          (error) => {
            console.warn(error);
            setIsAdmin(false);
          }
        )
  }, [props])

  function toggleEditable(e) {
    e.preventDefault();
    if (editable) {
      setEditable(false)
    } else {
      setEditable(true)
    }
  }

  // const title = (props.stage.value && props.stage.value.payLoad !== null ? props.stage.value.payLoad.name : "");
  const participants = (props.participants && props.participants.payLoad !== null ? props.participants.payLoad : []);
  const waitlist = (props.waitlist && props.waitlist.payLoad !== null ? props.waitlist.payLoad : [])
  const stage = (props.stage && props.stage.payLoad !== null ? props.stage.payLoad : {});
  if (stage.isDone === true || editable) {
    return (
      <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} style={{ padding: '0 50px'}}>
      <Card loading={props.pending || loading} title={stage.name} style={{ marginTop: '24px' }}>
        <Row gutter={16}>
          <Col span={8}>
            <Statistic title="Date" value={dateFormat(stage.date)} prefix={<CalendarOutlined />} />
          </Col>
          <Col span={8}>
            <Statistic title="Rounds" value={stage.turns} prefix={<MergeCellsOutlined />} />
          </Col>
          <Col span={8}>
            <Statistic title="Players" value={`${stage.playerAttendancy} (cap: ${stage.playerCap})`} prefix={<TeamOutlined />}/>
          </Col>
        </Row >
        <Row justify="center">
          { Setting.isLoggedIn() && !stage.isDone &&
            <Col span={8}><SubscribeStage onSubscribe={props.subscribe} stageId={stage.id} registrationInfo={isRegistered} /></Col>
          }
          { Setting.isLoggedIn() && isAdmin && !stage.isDone && 
            <Col span={8}><AddStageParticipant onAddPlayer={props.addPlayer} stageId={stage.id}/></Col>
          }
        </Row>
        <Divider>Stage Ranking</Divider>
        <Row>
          <Col span={24}>
            {
              Setting.isLoggedIn() && (isAdmin || hasRights.isReferral) && stage.isDone !== true && stage.playerAttendancy > 0 && editable === false &&
              <Row justify="center">
                <Col span={4}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">UPDATE RANKING</Button></Col>
              </Row>
            }
            {
              Setting.isLoggedIn() && (isAdmin || hasRights.isReferral) && stage.isDone === true && editable === false &&
              <Row justify="center">
                <Col span={4}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">EDIT RANKING</Button></Col>
              </Row>
            }
            <RankingTable admin={isAdmin} editing={editable} toggleEditing={toggleEditable} dataSource={participants} {...props} />
          </Col>
        </Row>
      </Card>
      </motion.div>
    );
  }
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} style={{ padding: '0 50px'}}>
    <Card loading={props.pending || loading} title={stage.name} style={{ marginTop: '24px' }}>
        <Row gutter={16}>
          <Col span={8}>
            <Statistic title="Date" value={dateFormat(stage.date)} prefix={<CalendarOutlined />} />
          </Col>
          <Col span={8}>
            <Statistic title="Rounds" value={stage.turns} prefix={<MergeCellsOutlined />} />
          </Col>
          <Col span={8}>
            <Statistic title="Players" value={`${stage.playerAttendancy} (cap: ${stage.playerCap})`} prefix={<TeamOutlined />}/>
          </Col>
        </Row >
        <Row justify="center">
          { Setting.isLoggedIn() && !stage.isDone &&
            <Col span={8}><SubscribeStage onSubscribe={props.subscribe} stageId={stage.id} registrationInfo={isRegistered} /></Col>
          }
          { Setting.isLoggedIn() && (isAdmin || hasRights.isReferral) && !stage.isDone && 
            <Col span={8}><AddStageParticipant onAddPlayer={props.addPlayer} stageId={stage.id}/></Col>
          }
        </Row>
        <Divider>Players</Divider>
        {
          Setting.isLoggedIn() && (isAdmin || hasRights.isReferral) && stage.isDone !== true && stage.playerAttendancy > 0 && editable === false &&
          <Row justify="center">
            <Col span={4}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">UPDATE RANKING</Button></Col>
          </Row>
        }
        {
          Setting.isLoggedIn() && (isAdmin || hasRights.isReferral) && stage.isDone === true && editable === false &&
          <Row justify="center">
            <Col span={4}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">EDIT RANKING</Button></Col>
          </Row>
        }
        <Row>
          <Col span={12} style={{padding: '10px'}}>
            <ParticipantTable admin={isAdmin} rights={hasRights} editing={editable} toggleEditing={toggleEditable} dataSource={participants} {...props} />
          </Col>
          <Col span={12} style={{padding: '10px'}}>
            <WaitlistTable admin={isAdmin} rights={hasRights} editing={editable} toggleEditing={toggleEditable} dataSource={waitlist} {...props} />
          </Col>
        </Row>
      </Card>
      </motion.div>
  );
}

export default Stage;
// export default Domanda;